/* Cap the product-page quantity stepper at the available stock.
   Only applies to variants that track inventory and do not allow overselling. */
(function () {
  'use strict';

  function limitFor(section) {
    var dataEl = section.querySelector('[data-variants]');
    var idInput = section.querySelector('[data-variant-input]');
    if (!dataEl || !idInput) return null;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return null; }
    var variant = variants.find(function (v) { return String(v.id) === String(idInput.value); });
    if (!variant) return null;
    if (variant.tracked === 'shopify' && variant.policy === 'deny' && variant.available) {
      return Math.max(1, variant.qty || 0);
    }
    return null;
  }

  function apply(section) {
    var input = section.querySelector('[data-qty-input]');
    if (!input) return;
    var max = limitFor(section);
    var value = parseInt(input.value, 10) || 1;
    if (max) {
      input.max = max;
      if (value > max) { input.value = max; value = max; }
    } else {
      input.removeAttribute('max');
    }
    var plus = section.querySelector('[data-qty-step="1"]');
    if (plus) {
      var atMax = !!max && value >= max;
      plus.disabled = atMax;
      plus.setAttribute('aria-disabled', atMax ? 'true' : 'false');
    }
  }

  function applyAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-product-section]'), apply);
  }

  ['click', 'change', 'input'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      var section = e.target.closest && e.target.closest('[data-product-section]');
      if (section) apply(section);
    });
  });

  document.addEventListener('shopify:section:load', applyAll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyAll);
  else applyAll();
})();
